import { render, staticRenderFns } from "./Geraete.vue?vue&type=template&id=4676d4c9&"
import script from "./Geraete.vue?vue&type=script&lang=js&"
export * from "./Geraete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports